import Spinner from '@carvana/ds-spinner';
import React from 'react';
import styles from './checking-spinner.module.css';

interface CheckingSpinnerProps {
  showMessage?: boolean;
}

const CheckingSpinner: React.FC<CheckingSpinnerProps> = ({ showMessage = true }) => (
  <div className={styles.container}>
    <Spinner size={48} />
    <p className={`${styles.message}${showMessage ? '' : ` ${styles.messageHidden}`}`}>
      Checking for requirements
    </p>
  </div>
);

export default CheckingSpinner;
